require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-gary-vaynerchuk.json") })
        }
      }, "path---tags-gary-vaynerchuk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-gary-vaynerchuk!./.cache/json/tags-gary-vaynerchuk.json
// module id = 324
// module chunks = 231608221292675